import store from "../index.js";
import api from "../../utils/api";
import UserConstant from "../../mixins/user/const/userConstant.js";
import AlfieAcConstant from "@/mixins/alfie/const/alfieAcConstant";
import { ALARMED_TYPE } from "@/enum/report/alarmed_type.js";

export const modules = {
  store,
};

export const state = {
  _name: " ",
  _email: " ",
  _mobile: " ",
  _channelTalk: {},
  _realtorInfo: {},
  _roleType: "",
  _code: "",
  _count: 0,
  _discount: false,
  _needMobile: false,
  _isMobileValid: false,
  _deviceInfo: {
    push_token: "",
    platform: "",
    os_version: "",
    device_info: "",
    app_name: "",
    app_version: "",
    app_build_number: "",
    app_install_time: "",
    app_update_time: "",
  },
  _deviceInfoSubmitted: false,
};

export const mutations = {
  [UserConstant.ADD_INVITE_CODE]: (state, payload) => {},

  setUserName(state, item) {
    state._name = item;
  },
  setUserEmail(state, item) {
    state._email = item;
  },
  setUserMobile(state, item) {
    state._mobile = item;
  },
  setChannelTalkInfo(state, item) {
    state._channelTalk = item;
  },
  setUserCount(state, item) {
    state._count = item ? Number(item) : 304452;
  },
  setWelcome(state, item) {
    state._discount = item;
  },

  setRealtorInfo(state, item) {
    state._realtorInfo = item;
  },

  setUserRoleType(state, item) {
    state._roleType = item;
  },
  setUserCode(state, item) {
    state._code = item;
  },
  setNeedMobile(state, item) {
    state._isMobileValid = item.isMobileValid;
    state._needMobile =
      !item.isMobileValid && (item.reportsCount > 0 || item.subscriptionsCount > 0);
    // window.console.log(`isMobileValid: ${state._isMobileValid}, needMobile: ${state._needMobile}`)
  },
  setDeviceInfo(
    state,
    {
      push_token,
      platform,
      os_version,
      device_info,
      app_name,
      app_version,
      app_build_number,
      app_install_time,
      app_update_time,
    },
  ) {
    state._deviceInfo = {
      push_token,
      platform,
      os_version,
      device_info,
      app_name,
      app_version,
      app_build_number,
      app_install_time,
      app_update_time,
    };
  },
  setDeviceInfoSubmitted(state, yn) {
    state._deviceInfoSubmitted = yn;
  },
  // 로그아웃 시 상태 초기화
  resetUserState(state) {
    state._name = " ";
    state._email = " ";
    state._mobile = " ";
    state._channelTalk = {};
    state._realtorInfo = {};
    state._roleType = "";
    state._code = "";
    state._count = 0;
    state._discount = false;
    state._needMobile = false;
    state._isMobileValid = false;
    state._deviceInfo = {
      push_token: "",
      platform: "",
      os_version: "",
      device_info: "",
      app_name: "",
      app_version: "",
      app_build_number: "",
      app_install_time: "",
      app_update_time: "",
    };
    state._deviceInfoSubmitted = false;
  },
};

export const actions = {
  async acAppleStateCode() {
    try {
      const url = `/api/v1/user/login/apple/state`;
      const res = await api.post(url);

      console.log("acAppleStateCode", res.data.state);

      return res.data.state;
    } catch (error) {
      console.log("acAppleStateCode error message", error.message);
      return null;
    }
  },

  async acAppleStateCodeConfirm({ commit }, state) {
    try {
      const url = `/api/v1/user/login/apple/confirm`;
      await api.post(url, {
        state: state,
      });
      return true;
    } catch (error) {
      console.log("acAppleStateCodeConfirm error message", error.message);
      console.log(commit);
      return false;
    }
  },
  async acTerm({ commit }, body) {
    try {
      const url = `/api/v1/user-terms`;
      const res = await api.post(url, {
        ...body,
      });
      console.log("acTerm", res.data);
      return true;
    } catch (error) {
      console.log("acTerm error message", error.response.data.message);
      console.log(commit);
      return false;
    }
  },
  async acTermSearch() {
    try {
      const url = `/api/v1/user-terms`;
      const res = await api.get(url);

      console.log("acTermSearch", res.data.state);

      return res.data.state;
    } catch (error) {
      console.log("acTermSearch error message", error.response.data.message);
      return false;
    }
  },
  async acUserName({ commit }) {
    try {
      const url = `/api/v1/user/name`;
      const res = await api.get(url);
      if (res.data.code === 0) {
        commit("setUserName", res.data.data.name);
        commit("setUserEmail", res.data.data.email);
        commit("setUserMobile", res.data.data.mobile);
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.log("acUserName error message", error.message);
      return false;
    }
  },
  async acUserType() {
    try {
      const url = `/api/v1/user/type`;
      const res = await api.get(url);
      return res?.data?.data?.type;
    } catch (error) {
      return null;
    }
  },

  async acUserRoleType({ commit }) {
    try {
      const url = `/api/v1/user/role`;
      const res = await api.get(url);

      commit("setUserRoleType", res.data?.data?.role);
      return true;
    } catch (error) {
      return null;
    }
  },
  async acWelcome({ commit }) {
    try {
      const url = `/api/v1/order-discount`;
      const res = await api.get(url);
      if (res.data?.code === 0) {
        commit("setWelcome", res.data?.data?.discount);
      }
      return res.data?.data;
    } catch (error) {
      return null;
    }
  },

  /**
   * 알피 위젯 신원 토큰(약 10분). 비로그인·실패면 null — 위젯은 비로그인 상담으로 뜬다.
   * 응답에 code 가 없어 apiWrapper(code===0 계약) 대신 api 를 쓴다. 토큰은 로그·화면에 남기지 않는다.
   */
  async acAlfieIdentityToken() {
    if (!localStorage.getItem("naezip_to_ac_se")) return null;
    try {
      const res = await api.post(AlfieAcConstant.POST_IDENTITY_TOKEN, {});
      const token = res?.data?.data?.token;
      return typeof token === "string" && token.length > 0 ? token : null;
    } catch (error) {
      return null;
    }
  },

  async acChannelTalk({ commit }) {
    try {
      const url = `/api/v1/user/info/channel-talk`;
      const res = await api.get(url);
      commit("setChannelTalkInfo", res?.data.data);
      return true;
    } catch (error) {
      return null;
    }
  },

  async acUserCount({ commit }) {
    try {
      const url = `/api/v1/user/info`;
      const res = await api.get(url);
      commit("setUserCount", res?.data.data?.count);
      return true;
    } catch (error) {
      return null;
    }
  },

  async acVerifyAuthcode({ commit }, params) {
    try {
      const url = `/api/v1/realtor/auth/code`;
      const res = await api.post(url, { ...params });

      if (res) {
        commit("setUserCode", params.auth_code);
      }
      return res;
    } catch (error) {
      return null;
    }
  },

  acRealtor({ commit }, params) {
    try {
      commit("setRealtorInfo", params);
    } catch (error) {
      return null;
    }
  },

  async acNeedMobile({ commit }) {
    try {
      const url = `/api/v1/user/need-mobile`;
      const res = await api.get(url);
      commit("setNeedMobile", res?.data?.data);
      return true;
    } catch (error) {
      return null;
    }
  },
  async acUpdateMobile({}, mobile) {
    try {
      const url = `/api/v1/user/mobile`;
      const res = await api.patch(url, { mobile });
      return res;
    } catch (error) {
      return null;
    }
  },
  async acSetDeviceInfo(
    { commit, state },
    {
      push_token,
      platform,
      os_version,
      device_info,
      app_name,
      app_version,
      app_build_number,
      app_install_time,
      app_update_time,
    },
  ) {
    try {
      commit("setDeviceInfo", {
        push_token,
        platform,
        os_version,
        device_info,
        app_name,
        app_version,
        app_build_number,
        app_install_time,
        app_update_time,
      });
      window.console.log("SET DEVICE INFO: ", JSON.stringify(state._deviceInfo));
    } catch (error) {
      return null;
    }
  },
  async acRegisterPushDevice({ state, commit }) {
    try {
      if (state._deviceInfo.push_token?.length <= 0) {
        return false;
      }
      // if (state._deviceInfoSubmitted) {
      //   return true;
      // }
      const url = `/api/v1/user/push-device`;
      await api.post(url, { ...state._deviceInfo });
      commit("setDeviceInfoSubmitted", true);
      return true;
    } catch (error) {
      window.console.log(
        "acRegisterPushDevice error: ",
        error.message,
        JSON.stringify(error.response.data),
      );
      return false;
    }
  },

  async acSignupUserCampaingSave({ commit }, params) {
    try {
      const url = `/api/v1/user/signup/campaign`;
      const res = await api.post(url, { ...params });
      return res?.data?.code === 0;
    } catch (error) {
      return null;
    }
  },
  async acSetSpecialLoanAlarm() {
    try {
      const url = `/api/v1/user-alarmed`;
      const result = await api.post(url, {
        alarmed_type: ALARMED_TYPE.SPECIAL_LOAN,
        meta_data: null,
      });
      return result?.data?.code === 0;
    } catch (error) {
      return false;
    }
  },
  async acCheckSpecialLoanAlarm() {
    try {
      const url = `/api/v1/user-alarmed/check`;
      const result = await api.get(url, { params: { alarmed_type: ALARMED_TYPE.SPECIAL_LOAN } });
      return result?.data?.data?.alarmed || false;
    } catch (error) {
      return false;
    }
  },
};

// NZSC-3151 계약상담(alfred) 오픈 비율(%). 0=테스터만 / 100=전체(로그인 유저).
// 다이얼/킬은 이 값만 바꿔 재배포(web Vercel). loan-relay·firstam·sherlock 게이트와 무관.
// 2026-06-19 전체 오픈(100). 비로그인은 빈이메일 가드로 여전히 제외(정상 — 로그인+@ 필요).
const ALFRED_ROLLOUT_PERCENT = 100;

// 2026-06-19 GNB 계약상담 탭 전체 노출(비로그인 포함). 탭=발견용이라 로그인 무관 노출하고,
// 실제 진입은 라우트 가드가 로그인 요구(비로그인 탭클릭 → 로그인 유도). false면 월세페이 탭으로 복귀(킬).
const ALFRED_TAB_OPEN = true;

// 이메일 → 0~99 균등 버킷 (FNV-1a 32bit). FE 스토어에 user_no가 없어 _email로 해시.
// 같은 이메일은 항상 같은 버킷 → 새로고침해도 노출이 흔들리지 않음.
const fnAlfredBucket = email => {
  let hash = 0x811c9dc5;
  for (let i = 0; i < email.length; i += 1) {
    hash ^= email.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193);
  }
  return (hash >>> 0) % 100;
};

export const getters = {
  isInternalTester: state => {
    return [
      "hsm9534@naver.com",
      "skmshj@nate.com",
      "comethru42@daum.net",
      "ganzy18@naver.com",
      "bible_min@kredatalab.com",
      "kvgvsbp6z5@privaterelay.appleid.com",
      "gttfmyhjrj@privaterelay.appleid.com",
      "mojamoja8@naver.com",
    ].includes(state._email);
  },
  // 계약상담(alfred) 노출 = 내부 테스터 OR 롤아웃 버킷 안. 계약상담 전용(다른 테스터 게이트와 분리).
  isAlfredAvailable: (state, getters) => {
    // 내부 테스터는 비율과 무관하게 항상 노출
    if (getters.isInternalTester) return true;
    // 빈/미로드 이메일(" ")은 무조건 제외 — 로딩 갭에 비대상자한테 번쩍이는 것 방지
    const email = (state._email || "").trim();
    if (!email.includes("@")) return false;
    return fnAlfredBucket(email) < ALFRED_ROLLOUT_PERCENT;
  },
  // GNB 계약상담 탭 노출 = 전체(비로그인 포함). 로그인/버킷 무관 — 발견용. 실제 사용은 가드가 로그인 요구.
  isAlfredTabVisible: () => ALFRED_TAB_OPEN,
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
